module.exports = __webpack_public_path__ + "img/BGMain.b86991f7.jpg";